import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, CircularProgress, Typography } from '@mui/material';
import EventDetailsComponent from '../../events/EventDetailsComponent';
import api from '../../../services/api';

const EventDetailsModal = ({ open, onClose, eventId }) => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEvent = async () => {
      if (!open || !eventId) {
        setEvent(null);
        return;
      }
      try {
        setLoading(true);
        const res = await api.get(`/v1/api/events/${eventId}`);
        setEvent(res.data);
      } catch (err) {
        console.error('Failed to load event', err);
        setEvent(null);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [open, eventId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Event Details</DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : event ? (
          <Box sx={{ p: 5 }}>
            <EventDetailsComponent event={event} loading={false} />
          </Box>
        ) : (
          <Box sx={{ p: 3 }}>
            <Typography variant="body2">No event selected or failed to load.</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EventDetailsModal;
